import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Image } from "@/content/templates/template.types.ts";

import { expectContent } from "../../../../content/utils/expectContent";

export interface AgileHeroProps {
    headerText: string;
    secondaryText: string;
    backgroundPicture: Image | null;
}

export const AgileHero = ({
    headerText,
    secondaryText,
    backgroundPicture
}: AgileHeroProps) => {
    const heroCss = css({
        textAlign: "center",
        backgroundImage: `url(${expectContent(backgroundPicture).url})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        marginInlineStart: "auto",
        marginInlineEnd: "auto",
        paddingBlockStart: "64px",
        paddingBlockEnd: "64px",
        paddingInlineStart: "16px",
        paddingInlineEnd: "16px",
        minWidth: "100%",
        clear: "both",
        color: "#fff"
    });

    const headerCss = css({
        fontWeight: "400",
        fontSize: "2rem",
        marginBlockStart: "16px",
        marginBlockEnd: "16px",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        letterSpacing: "0",
        lineHeight: "1.18181818",

        [media.above.sm]: {
            fontSize: "2.75rem"
        },

        [media.above.lg]: {
            fontSize: "3rem"
        }
    });

    const secondaryCss = css({
        fontSize: "1.25rem",
        fontFamily: "Charlie Display",
        letterSpacing: ".3px",
        lineHeight: "1.4",
        fontWeight: "200",
        marginBlockEnd: "16px"
    });

    const capitalize = (title: string) => {
        return title.charAt(0).toUpperCase() + title.slice(1);
    };

    return (
        <div css={heroCss}>
            <h1 css={headerCss}>{capitalize(expectContent(headerText))}</h1>
            <p css={secondaryCss}>{secondaryText}</p>
        </div>
    );
};
